export const COMMON_REDUCER_NAMES = {
  ENTITIES: 'entities',
  ATTRIBUTES: 'attributes',
};
